import * as React from 'react';
import { Modal as BootstrapModal } from 'react-bootstrap';
import axios from 'axios';
import * as api from '../../../../data/api/api';
import { IQuoteActions } from '../../../../services/quote/models';

const ModalHeader = BootstrapModal.Header;
const ModalTitle = BootstrapModal.Title;
const ModalBody = BootstrapModal.Body;

interface IPaymentModalProps {
    transactionId: string;
    actions: {
        quote: IQuoteActions;
        push: (route: string) => void;
    };
    showModal: boolean;
}

interface IPaymentModalState {
    showModal: boolean;
}

class PaymentModal extends React.Component<IPaymentModalProps, IPaymentModalState>  {
    public state = {
        showModal: true,
    };

    constructor(props) {
        super(props);
        this.handleWindowMessage = this.handleWindowMessage.bind(this);
    }

    public componentDidMount() {
        if (process.env.BROWSER) {
            window.addEventListener('message', this.handleWindowMessage);
        }
    }

    public componentWillUnmount() {
        if (process.env.BROWSER) {
            window.removeEventListener('message', this.handleWindowMessage);
        }
    }

    public closeModal() {
        this.setState({
            showModal: false,
        });
    }

    public handleWindowMessage(event)  {
        const { actions } = this.props;

        // For Chrome, the origin property is in the event.originalEvent object.
        const origin = event.origin || event.originalEvent.origin;

        if (origin !== axios.defaults.baseURL) {
            return;
        }

        const data = event.data;

        this.scrollToTop();

        if (data.status !== 'complete') {
            // Show an error?

            // console.log('Payment not complete', data.message, data);
            actions.quote.error('Payment Error: ' + data.message);
            this.closeModal();

            return;
        }

        actions.quote.complete(data.policies[ 0 ]);
        this.closeModal();

        actions.quote.addStepToWizard('complete', false);

        actions.push('/complete');
    }

    private scrollToTop = () => {
        if (process.env.BROWSER) {
            window.scrollTo(0, 0);
        }
    }

    public render() {
        const { transactionId} = this.props;

        const show = this.props.showModal && this.state.showModal;
        if (!show) {
            return null;
        }

        return (
            <BootstrapModal
                show={show}
                onHide={this.closeModal}
                bsSize="large"
                keyboard={false}
                backdrop="static"
                className="payments-modal"
            >
                <ModalHeader>
                    <ModalTitle>Payment</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <iframe src={api.getPaymentUrl(transactionId)}/>
                </ModalBody>
            </BootstrapModal>
        );
    }
}

export default PaymentModal;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/components/PaymentModal/index.tsx